// import * as pdfjsLib from "@/utils/pdf/pdf.min.mjs";

/**
 * OSS图片压缩
 * @param src 图片地址
 * @param options 参数
 * @returns
 */
export const OSSImageCompress = (src, options) => {
  let args = [];
  if (options.width) {
    args.push(`w_${options.width}`);
  }
  if (options.height) {
    args.push(`h_${options.height}`);
  }
  if (options.quality) {
    args.push(`/quality,Q_${options.quality}`);
  }
  args.filter(Boolean).join(",");

  return `${src}?x-oss-process=image/resize,${
    options.scaleType ? options.scaleType : m_fill
  },limit_0,${args}`;
};

// pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
//   "@/utils/pdf/pdf.worker.mjs",
//   import.meta.url
// ).toString();

// export const generatePdfThumbnail = async (url) => {
//   try {
//     const loadingTask = pdfjsLib.getDocument(url);
//     const pdf = await loadingTask.promise;

//     const page = await pdf.getPage(1);

//     // 设置缩放比例
//     const viewport = page.getViewport({ scale: 2 });

//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");
//     canvas.height = viewport.height;
//     canvas.width = viewport.width;

//     const renderContext = {
//       canvasContext: context,
//       viewport: viewport,
//     };

//     await page.render(renderContext).promise;

//     const thumbnailUrl = canvas.toDataURL("image/png");
//     return thumbnailUrl;
//   } catch (error) {
//     console.error("生成PDF缩略图失败:", error);
//     return null;
//   }
// };

/**
 * 秒转换为时分秒
 * @param second
 * @returns
 */
export function formatSecond(second) {
  second = Math.floor(second);
  const hour = Math.floor(second / 3600);
  const minute = Math.floor((second - hour * 3600) / 60);
  const sec = second - hour * 3600 - minute * 60;
  let result = "";
  if (hour > 0) {
    result += `${hour.toString().padStart(2, "0")}小时`;
  }

  if (hour > 0 || minute > 0) {
    result += `${minute.toString().padStart(2, "0")}分`;
  }

  result += `${sec.toString().padStart(2, "0")}秒`;

  return result;
}

export function isWx() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("micromessenger");
}
